<template>
  <div class="row">
    <!-- <div class="col-xl-12 col-lg-12 col-md-12">
      <user-card> </user-card>

    </div> -->
    <div class="col-xl-12 col-lg-12 col-md-12">
        <!-- <members-card> </members-card> -->
        <user-card> </user-card>
        <SystemList> </SystemList>
    </div>

  </div>
</template>
<script>
import EditProfileForm from "./UserProfile/EditProfileForm.vue";
import UserCard from "./UserProfile/UserCard.vue";
import MembersCard from "./UserProfile/MembersCard.vue";
import SystemList from "./UserProfile/SystemList.vue";
export default {
  components: {
    EditProfileForm,
    UserCard,
    MembersCard,
    SystemList
  },
};
</script>
<style></style>
